import { Card } from "react-bootstrap";
import styled from "styled-components";

import { Profile } from "../ProfileDetailView";
import { generateTypeDisplayName } from "../ProfileManageMentView";

type ProfileDetailProps = {
    data: Profile;
};

const CardHeaderDivStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ProfileDetail = ({ data }: ProfileDetailProps): JSX.Element => {
    return (
        <>
            <Card className="mb-2 border-0">
                <dl>
                    <CardHeaderDivStyled>
                        <h1 className="rem-1-5">Details</h1>
                    </CardHeaderDivStyled>

                    <hr className="bg-border-grey my-3" />
                    <div className="mb-2">
                        <dt className="rem-1">Profile Type</dt>
                        <dd className="fw-bold">
                            {generateTypeDisplayName(data.profileType)}
                        </dd>
                    </div>

                    <div className="mb-2">
                        <dt className="rem-1">Profile Name</dt>
                        <dd className="fw-bold">{data.profileName}</dd>
                    </div>
                    <div className="mb-2">
                        <dt className="rem-1">Profile Country & City</dt>
                        <dd className="fw-bold">{data.profileCountryCity}</dd>
                    </div>
                </dl>
            </Card>
            <Card className="mb-2 border-0">
                <dl>
                    <CardHeaderDivStyled>
                        <h1 className="rem-1-5">Contact Person</h1>
                    </CardHeaderDivStyled>

                    <hr className="bg-border-grey my-3" />
                    <div className="mb-2">
                        <dt className="rem-1">Contact Person Name</dt>
                        <dd className="fw-bold">{data.contactPersonName}</dd>
                    </div>

                    <div className="mb-2">
                        <dt className="rem-1">Contact Person Number</dt>
                        <dd className="fw-bold">{data.contactPersonNumber}</dd>
                    </div>
                    <div className="mb-2">
                        <dt className="rem-1">Contact Person Email Address</dt>
                        <dd className="fw-bold">{data.contactPersonEmail}</dd>
                    </div>
                </dl>
            </Card>
        </>
    );
};
